<template>
  <div>
    <div class="mian">
      <!-- 头部 -->
      <!-- <div class="top">
          <img src="../assets/images/头部框.png" alt="" />
          <div class="info">
            <span>交易信息</span>
          </div>
          <div class="num">
            <span>04</span>
          </div>
        </div> -->
      <div>
        <div class="material">
          <div class="dian"></div>
          <div class="m-title">货物信息</div>
        </div>
        <div class="picture" v-if="cargo_imgs.length > 0">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in cargo_imgs" :key="index">
              <img
                :src="item.file_url"
                alt=""
                class="img"
                style="width: 100%; height: 100%"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="goodsInfo goodsInfo2">
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">货物名称：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.cargo_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">货物编码：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.cargo_no }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">货物类别：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.cargo_group_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">净重(kg)：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.cargo_nw }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">生产日期：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.production_date }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">货主：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.customer_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">货主编号：</div>
            <div class="goodsInfo-text-num texts">
              {{ info.customer_no }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="info.parameters.length > 0">
        <div class="material">
          <div class="dian"></div>
          <div class="m-title">其他信息</div>
        </div>
        <div class="goodsInfo goodsInfo2">
          <div
            class="goodsInfo-text"
            v-for="(item, index) in info.parameters"
            :key="index"
          >
            <div style="word-break: keep-all">{{ item.parameter_name }}：</div>
            <div class="goodsInfo-text-num texts">
              {{ item.parameter_value }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="material">
          <div class="dian"></div>
          <div class="m-title">出入库记录</div>
        </div>
        <div
          class="goodsInfo goodsInfo2"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">仓储名称：</div>
            <div class="goodsInfo-text-num texts">
              {{ item.wh_name }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">仓储位置：</div>
            <div class="goodsInfo-text-num texts">
              {{ item.address }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">
              {{ item.store_change_type == 1 ? "出库单号" : "入库单号" }}：
            </div>
            <div class="goodsInfo-text-num texts">
              {{ item.s_no }}
            </div>
          </div>
          <div class="goodsInfo-text">
            <div style="word-break: keep-all">发生时间：</div>
            <div class="goodsInfo-text-num texts">
              {{ item.record_date | formant }}
            </div>
          </div>
          <!-- <div class="goodsInfo-text">
              <div>
                价格
              </div>
              <div class="goodsInfo-text-num texts" style="margin-left: 65px;">
                {{ list[0].op.op.price }}元
              </div>
            </div>-->
          <!-- <div class="goodsInfo-text">
            <div style="width: 65px">时间</div>
            <div class="goodsInfo-text-num texts" style="margin-left: 24px">
              {{ list.op.op.created_date.slice(0, 10) }}
            </div>
          </div> -->
          <div class="goodsInfo-text">
            <div class="goods-title" style="word-break: keep-all">
              区块链标识：
            </div>
            <div class="goodsInfo-text-num texts" style="word-wrap: break-word">
              {{ item.chain_id }}
            </div>
          </div>
        </div>
        <!-- <div class="goods-characteristic">
            <div class="goods-characteristic-inner">
              <span @click="toBlockChain"> 区块链标识：{{ list.txid }}</span>
            </div>
          </div> -->
      </div>
      <div v-if="info.cargo_image_evidence.length > 0">
        <div class="material">
          <div class="dian"></div>
          <div class="m-title">图像存证</div>
        </div>
        <div class="picture">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item
              v-for="(item, index) in info.cargo_image_evidence"
              :key="index"
            >
              <img
                :src="item.file_url"
                alt=""
                class="img"
                style="width: 100%; height: 100%"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div v-if="info.video_image_evidence.length > 0">
        <div class="material">
          <div class="dian"></div>
          <div class="m-title">视频存证</div>
        </div>
        <div class="picture">
          <div
            class="my-swipe"
            v-for="(item, index) in info.video_image_evidence"
            :key="index"
          >
            <video
              controls
              x5-video-player-type="h5"
              :src="item.file_url"
              style="width: 100%; height: 100%"
            ></video>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <sertificate :ts="ts" :txid="txid" />
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import Vue from "vue";
import { Swipe, SwipeItem, Overlay } from "vant";
import { ImagePreview } from "vant";
import Sertificate from "../components/Sertificate.vue";

Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay);

export default {
  components: { Sertificate },

  props: {
    czInfo: Object,
  },
  watch: {
    czInfo(curVal, oldVal) {
      console.log(oldVal, "oldVal");
      if (curVal) {
        console.log(curVal);
        // this.jyInfo = curVal;
        // console.log(this.jyInfo.data_list, "oldVal");

        this.czInfo.data_list.forEach((item) => {
          item.msgItems.forEach((i) => {
            i.op.op = JSON.parse(i.op.op);
          });
        });
        // console.log(this.czInfo, "czInfo");

        this.list =
          this.czInfo.data_list[0].msgItems[0].op.op.storeChangeRecords;
        this.cargo_imgs = this.czInfo.data_list[0].msgItems[0].op.op.cargo_imgs;
        this.info = this.czInfo.data_list[0].msgItems[0].op.op;
        // console.log(this.list, "list");
        // this.list.forEach((item) => {
        //   if (item.op.op.receiver_name) {
        //     this.receiver_name = item.op.op.receiver_name;
        //     console.log(
        //       "------------------------------------------------------------",
        //       this.receiver_name
        //     );
        //   }
        // });
        // this.list.forEach((item) => {
        //   this.listPic = item.msgItems[0];
        // });
        // this.listInfo = this.listPic.op.op.picurl.split(",").slice(0, 3);
      }
    },
  },
  data() {
    return {
      listData: [],
      list: [],
      info: {},
      receiver_name: "",
      show: false,
      ts: "",
      txid: "",
      cargo_imgs: [],
    };
  },
  created() {
    // this.listData = JSON.parse(
    //   window.localStorage.getItem("defalutObj")
    // )
    // console.log('liu', this.listData);
    // this.list = this.listData.filter(item => item.trace_name === '交易信息')
    // this.list.forEach(item => {
    //   this.list = item.msgItems
    // })
    // this.list.forEach(item => {
    //   if(item.op.op.receiver_name) {
    //     this.receiver_name = item.op.op.receiver_name
    //     console.log('------------------------------------------------------------',this.receiver_name);
    //   }
    // })
    // console.log('liutong', this.list[0].op.op)
  },
  methods: {
    switch_image(img) {
      ImagePreview([img]);
    },
    toBlockChain() {
      this.show = true;
      this.ts = this.list.ts;
      this.txid = this.list.txid;
      // console.log(this.list);
      // this.$router.push(`/Look?ts=${this.list.ts}&txid=${this.list.txid}`);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.picture {
  margin: 60px auto;
  width: 660px;
  height: 660px;
  .my-swipe {
    width: 100%;
    height: 100%;
  }
}
.material {
  display: flex;
  // width: 548px;
  height: 49px;

  align-items: center;
  margin: 0 auto;
  border-bottom: 2px solid #e8e8e8;
  .dian {
    width: 12px;
    height: 12px;
    background: #000000;
    border-radius: 50%;
    opacity: 1;
    // margin-right: -330px;
    font-size: 28px;
  }
  .m-title {
    color: #000;
    // width: 112px;
    height: 40px;
    font-weight: 400;
    // line-height: 0px;
    margin-left: 15px;
    // margin-top: 5px;
  }
  .date {
    width: 250px;
    height: 28px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 28px;
    color: #919ab1;
    opacity: 1;
  }
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mian {
  position: relative;
  width: 608px;
  margin-bottom: 20px;
  padding: 0 16px 0 16px;
  background-color: #fff;
  .top {
    position: relative;
    img {
      width: 100%;
    }
    .info {
      position: absolute;
      top: 9vw;
      left: 6vw;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 0px;
      color: #fff;
      opacity: 1;
    }
    .num {
      color: transparent;
      -webkit-text-stroke: 1px #127855;
      font-size: 11vw;
      position: absolute;
      top: 15px;
      left: 240px;
    }
  }
  .product {
    width: 638px;
    height: 828px;
    background-color: skyblue;
    padding: 172px 0 30px 56px;
    border: #02b152 solid 10px;
    .text {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-right: 45px;
      margin-top: -13vw;
      .text-top {
        color: #007d5f;
        font-weight: bold;
        line-height: 0px;
        opacity: 1;
        font-size: 32px;
        margin-bottom: 30px;
      }
      .text-bottom {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 0px;
        color: #000000;
        opacity: 1;
      }
    }
    .picture {
      width: 496px;
      height: 818px;
      border: 2px solid #707070;
      opacity: 1;
      border-radius: 0px;
      margin: 34px 60px 0 50px;
    }
  }
  .goodsInfo2 {
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;

    color: #919ab1;
    opacity: 1;
  }
  .goodsInfo {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 544px;
    border: 2px solid #f3f3f3;
    opacity: 1;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 36px;
    padding-bottom: 30px;
    .goodsInfo-text-num {
      white-space: pre-line;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .texts {
      font-family: PingFang SC;
      font-weight: 400;

      color: #000000;
      opacity: 1;
    }
    .goodsInfo-text {
      margin-top: 30px;
      display: flex;
      margin-left: 20px;
    }
  }
  .goods-characteristic {
    margin: 0 auto;
    width: 536px;
    padding-bottom: 20px;
    .goods-characteristic-inner {
      margin: 0 auto;
      line-height: 38px;
      padding: 12px 30px;
      font-size: 28px;
      color: #11745f;
      border: 1px solid #11745f;
      border-radius: 32px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .b-material {
    .swipe-wrap {
      width: 546px;
      height: 250px;

      margin: 0 auto;
      .my-swipe {
        width: 100%;
        height: 100%;
      }
    }
    .material {
      display: flex;
      justify-content: space-between;
      width: 548px;
      height: 49px;

      align-items: center;
      margin: 0 auto;
      border-bottom: 2px solid #e8e8e8;
      .dian {
        .m-title {
          width: 112px;
          height: 40px;
          font-weight: 400;
          line-height: 0px;
          margin-left: 15px;
          margin-top: 5px;
        }
        width: 12px;
        height: 12px;
        background: #000000;
        border-radius: 50%;
        opacity: 1;
        margin-right: -330px;
        font-size: 28px;
      }
      .date {
        width: 250px;
        height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 28px;
        color: #919ab1;
        opacity: 1;
      }
    }
  }
}
</style>